// AdminTeam.js
import { Outlet, useLocation, Navigate, useNavigate } from "react-router-dom";
import "./AdminTeam.css";

// MUI Icons
import PeopleIcon from "@mui/icons-material/People";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import SecurityIcon from "@mui/icons-material/Security";
import HistoryIcon from "@mui/icons-material/History";
import { LockOutlined } from "@mui/icons-material";

const AdminTeam = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname.split("/").pop();

  const tabs = [
    { key: "list", label: "Admin List", icon: <PeopleIcon /> },
    { key: "add", label: "Add Admin", icon: <PersonAddIcon /> },
    { key: "roles", label: "Roles & Permissions", icon: <SecurityIcon /> },
    { key: "activity", label: "Activity Log", icon: <HistoryIcon /> },
    { key: "2fa", label: "Two-Factor Auth", icon: <LockOutlined /> },
  ];

  const getTitle = () => {
    const found = tabs.find((t) => t.key === path);
    return found ? found.label : "Admin Team";
  };

  return (
    <div className="admin-team-container">
      <div className="data_head">
        <h1 className="data_heading">{getTitle()}</h1>
      </div>

      <div className="admin-team-content">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminTeam;
